<form (ngSubmit)="onSubmit()" [formGroup]="form" class="home-dialog fixActionRow">
  <div class="home-dialog__header">
    <h1 class="home-dialog__title">Holidays</h1>
    <p class="home-dialog__subtitle">
      Days the business closes, or stays open by exception. Dates are set for the current year each time you apply.
    </p>
    <button type="button" class="home-dialog__close" mat-dialog-close aria-label="Close">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="home-dialog__content xs:!overflow-x-hidden">
    <!-- One outlined row per holiday: the picker with its current-year date under it, the
         Open/Closed toggle and the trash — the native Holidays dialog, one to one. -->
    <div class="hd-holiday" *ngFor="let hour of form.controls; index as i" [formGroupName]="i">
      <span class="hd-holiday__main">
        <mat-form-field appearance="outline" class="hd-select hd-holiday__select">
          <mat-select formControlName="holiday_name" placeholder="Add holiday" panelClass="hd-select-panel">
            <mat-option *ngFor="let holiday of holiday_names" [value]="holiday">{{ holiday }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="hd-holiday__date">{{ holidayDate(hour.value.holiday_name) }}</span>
      </span>

      <mat-slide-toggle formControlName="is_open"></mat-slide-toggle>
      <span class="hd-state" [class.hd-state--on]="hour.value.is_open"
        [class.hd-state--closed]="!hour.value.is_open">{{ hour.value.is_open ? 'Open' : 'Closed' }}</span>

      <button type="button" class="hd-delete" (click)="delete(i)" aria-label="Delete holiday">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </div>

    <button class="hd-add" (click)="addNew()" type="button">Add holiday</button>
  </div>

  <mat-dialog-actions align="end" class="home-dialog__actions">
    <button type="button" class="hd-btn" mat-dialog-close>Cancel</button>
    <button type="submit" class="hd-btn hd-btn--primary">Apply</button>
  </mat-dialog-actions>
</form>
